import { normalizeRecorridoId } from '@/data/recorridos/config';
import t1Paradas from '@/data/paradas/t1Paradas.json';
import t2Paradas from '@/data/paradas/t2Paradas.json';
import t3Paradas from '@/data/paradas/t3Paradas.json';
import t4Paradas from '@/data/paradas/t4Paradas.json';
import t5aParadas from '@/data/paradas/t5aParadas.json';

/**
 * Itinerarios por recorrido y sentido.
 * t1a/t1b y t5a/t5b comparten itinerario (misma línea, variante de bus).
 * T1 Rangue: data/Paradas T1A y T1B.csv → scripts/generate_t1_paradas.py
 * T2: data/Paradas T2.csv → scripts/generate_t2_paradas.py
 * T3: data/Paradas T3.csv → scripts/generate_t3_paradas.py
 * T4: data/Paradas T4.csv → scripts/generate_t4_paradas.py
 * T5A: data/Paradas T5A.csv → scripts/generate_t5a_paradas.py (t5a/t5b usan los mismos nombres de T5A hasta tener CSV T5B).
 */
const ITINERARIO_T1 = {
  ida: t1Paradas.ida.map((p) => p.nombre),
  vuelta: t1Paradas.vuelta.map((p) => p.nombre),
};

const ITINERARIO_T2 = {
  ida: t2Paradas.ida.map((p) => p.nombre),
  vuelta: t2Paradas.vuelta.map((p) => p.nombre),
};

const ITINERARIO_T3 = {
  ida: t3Paradas.ida.map((p) => p.nombre),
  vuelta: t3Paradas.vuelta.map((p) => p.nombre),
};

const ITINERARIO_T4 = {
  ida: t4Paradas.ida.map((p) => p.nombre),
  vuelta: t4Paradas.vuelta.map((p) => p.nombre),
};

const ITINERARIO_T5 = {
  ida: t5aParadas.ida.map((p) => p.nombre),
  vuelta: t5aParadas.vuelta.map((p) => p.nombre),
};

export const ITINERARIOS = {
  t1a: ITINERARIO_T1,
  t1b: ITINERARIO_T1,
  t2: ITINERARIO_T2,
  t3: ITINERARIO_T3,
  t4: ITINERARIO_T4,
  t5a: ITINERARIO_T5,
  t5b: ITINERARIO_T5,
};

export function getItinerarioStops(recorridoId, sentido = 'ida') {
  const id = normalizeRecorridoId(recorridoId);
  if (!id || !ITINERARIOS[id]) return [];
  const s = sentido === 'vuelta' ? 'vuelta' : 'ida';
  return ITINERARIOS[id][s] || [];
}
